<template>
  <div class="user-card rounded-8px" :class="{ 'p-16px': padding }" :style="{ backgroundColor: bgColor }">
    <div class="flex items-start">
      <img
        class="avatar w-60px h-60px rounded-full flex-shrink-0"
        :src="data.avatarUrl || defaultAvatar"
        alt=""
      />
      <div class="flex-1 ml-10px">
        <div class="flex items-center">
          <span class="text-16px text-222 font-500 max-w-140px truncate">{{ data.nickname }}</span>
          <RoleTag
            v-if="data.level > 0"
            :level="data.level"
            :levelName="data.levelName"
            style-type="advanced"
          />
        </div>
        <div class="text-13px text-666 mt-8px">
          手机号码 {{ data.mobile }}
        </div>
        <div class="text-13px text-666 mt-8px" v-if="data.inviterLevelName">
          推荐人 {{ data.inviterLevelName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import RoleTag from '@/components/RoleTag.vue'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({
      avatarUrl: '',
      nickname: '',
      level: 0,
      levelName: '',
      mobile: '',
      inviterLevelName: '',
      inviterMobile: ''
    })
  },
  bgColor: {
    type: String,
    default: 'transparent'
  },
  padding: {
    type: Boolean,
    default: true
  }
})

const defaultAvatar = 'https://i.xurl.cn/x_dsx_h5/icons/default-head-white.png'
</script>